import { Tooltip } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  initTooltips();
});

export const initTooltips = (root: ParentNode = document) => {
  root.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]').forEach((element) => {
    if (Tooltip.getInstance(element)) return;

    const tooltip = Tooltip.getOrCreateInstance(element);

    element.addEventListener('click', () => {
      tooltip.hide();
      element.blur();
    });
  });
};
